import { clientActionPlatformChange } from './ClientAction'
import { ClientPlatformChangeActionEnum } from './generated'

export const PlatformChangeActions = {
  activateTradingEurope: clientActionPlatformChange({ action: ClientPlatformChangeActionEnum.ACTIVATE_TRADING_EUROPE }),
  suspendTradingEurope: clientActionPlatformChange({ action: ClientPlatformChangeActionEnum.SUSPEND_TRADING_EUROPE }),
  startOfDayEurope: clientActionPlatformChange({ action: ClientPlatformChangeActionEnum.START_DAY_EUROPE }),
  startOfDayEuropeTomorrow: clientActionPlatformChange({ action: ClientPlatformChangeActionEnum.START_DAY_EUROPE_TOMORROW }),
  endOfDayEurope: clientActionPlatformChange({ action: ClientPlatformChangeActionEnum.END_DAY_EUROPE }),
  activateTradingUS: clientActionPlatformChange({ action: ClientPlatformChangeActionEnum.ACTIVATE_TRADING_US }),
  suspendTradingUS: clientActionPlatformChange({ action: ClientPlatformChangeActionEnum.SUSPEND_TRADING_US }),
  preStartOfDayUS: clientActionPlatformChange({ action: ClientPlatformChangeActionEnum.PRE_START_DAY_US }),
  startOfDayUS: clientActionPlatformChange({ action: ClientPlatformChangeActionEnum.START_DAY_US }),
  endOfDayUS: clientActionPlatformChange({ action: ClientPlatformChangeActionEnum.END_DAY_US })
}
